import React, { useRef, useState } from 'react'
import { withOnlyGE } from '../../Device'
import ImageGallery from '../../genericComponents/ImageGallery'
import arrowLeft from '../../genericComponents/assets/arrow-left.svg'
import arrowRight from '../../genericComponents/assets/arrow-right.svg'
import point from '../../genericComponents/assets/point.svg'
import star from '../../genericComponents/assets/star.svg'
import SVGIcon from '../../svg/SVGIcon'
import s from './UserAccountIncentiveCarrousel.less'
import favoriteAddressesImg from './favorite_addresses.png'
import favoriteAddressesImgWebp from './favorite_addresses.webp'
import myAlertsImg from './my_alerts.png'
import myAlertsWebp from './my_alerts.webp'
import myOptionsImg from './my_options.png'
import myOptionsWebp from './my_options.webp'
import tripPriceImg from './trip_price.png'
import tripPriceWebp from './trip_price.webp'

const imageList = [
  {
    alt: 'Coût des mes trajets',
    original: tripPriceImg,
    srcSet: [tripPriceWebp]
  },
  {
    alt: 'Mes adresses favorites',
    original: favoriteAddressesImg,
    srcSet: [favoriteAddressesImgWebp]
  },
  {
    alt: 'Mes options de déplacement',
    original: myOptionsImg,
    srcSet: [myOptionsWebp]
  },
  {
    alt: 'Mes alertes',
    original: myAlertsImg,
    srcSet: [myAlertsWebp]
  }
]

export const UserAccountIncentiveCarrousel = withOnlyGE(() => {
  const [textIndex, setTextIndex] = useState(0)
  const galleryRef = useRef()

  const onBeforeSlide = nextIndex => {
    setTextIndex(nextIndex)
  }

  /*
    Calling `pause` before `slideToIndex` allows to reset the `slideInterval`
    So the `autoplay` won't use the remaining time but will reset it before sliding
   */
  const goToPreviousSlide = () => {
    galleryRef.current.pause()
    galleryRef.current.slideToIndex(galleryRef.current.getCurrentIndex() - 1)
    galleryRef.current.play()
  }

  const goToNextSlide = () => {
    galleryRef.current.pause()
    galleryRef.current.slideToIndex(galleryRef.current.getCurrentIndex() + 1)
    galleryRef.current.play()
  }

  const isBulletHighlighted = bulletIndex => (textIndex === bulletIndex ? s.highlightedBullet : s.bullet)

  return (
    <div className={s.carrouselSection}>
      <div className={s.imageCarrousel}>
        <div className={s.arrowContainer} onClick={goToPreviousSlide}>
          <SVGIcon url={arrowLeft} className={s.navArrow} />
        </div>
        <div className={s.galleryWrapper}>
          <ImageGallery
            ref={galleryRef}
            items={imageList}
            onBeforeSlide={onBeforeSlide}
            autoPlay
            slideInterval={5000}
          />
        </div>
        <div className={s.arrowContainer} onClick={goToNextSlide}>
          <SVGIcon url={arrowRight} className={s.navArrow} />
        </div>
      </div>
      {textIndex === 0 && (
        <div className={s.carrouselTextSection}>
          <h2 className={s.sectionTitle}>Je calcule le coût exact de mes trajets</h2>
          <ul className={s.popinList}>
            <li className={s.popinItem}>
              <SVGIcon url={star} className={s.icon} />
              Prix du péage selon le véhicule
            </li>
            <li className={s.popinItem}>
              <SVGIcon url={star} className={s.icon} />
              Consommation en carburant
            </li>
          </ul>
        </div>
      )}
      {textIndex === 1 && (
        <div className={s.carrouselTextSection}>
          <h2 className={s.sectionTitle}>Je trouve en un clic mes adresses favorites</h2>
          <ul className={s.popinList}>
            <li className={s.popinItem}>
              <SVGIcon url={star} className={s.icon} />
              Maison
            </li>
            <li className={s.popinItem}>
              <SVGIcon url={star} className={s.icon} />
              Travail
            </li>
            <li className={s.popinItem}>
              <SVGIcon url={star} className={s.icon} />
              Resto préféré...
            </li>
          </ul>
        </div>
      )}
      {textIndex === 2 && (
        <div className={s.carrouselTextSection}>
          <h2 className={s.sectionTitle}>Je retrouve mes options sur le site et l’appli mobile</h2>
          <ul className={s.popinList}>
            <li className={s.popinItem}>
              <SVGIcon url={star} className={s.icon} />
              Type de véhicule
            </li>
            <li className={s.popinItem}>
              <SVGIcon url={star} className={s.icon} />
              Prix du carburant
            </li>
            <li className={s.popinItem}>
              <SVGIcon url={star} className={s.icon} />
              Vitesse de marche ou à vélo
            </li>
          </ul>
        </div>
      )}
      {textIndex === 3 && (
        <div className={s.carrouselTextSection}>
          <h2 className={s.sectionTitle}>Je suis alerté des perturbations trafic</h2>
          <ul className={s.popinList}>
            <li className={s.popinItem}>Aujourd’hui sur l’appli et demain sur le site web</li>
          </ul>
        </div>
      )}
      <div className={s.carrouselBullets}>
        <SVGIcon url={point} className={isBulletHighlighted(0)} />
        <SVGIcon url={point} className={isBulletHighlighted(1)} />
        <SVGIcon url={point} className={isBulletHighlighted(2)} />
        <SVGIcon url={point} className={isBulletHighlighted(3)} />
      </div>
    </div>
  )
})
